//edelstahlgelaender
import {stahlgelaender} from '../../../assets/images/gelaender/stahlgelaender/data';
import {edelstahlgelaender} from '../../../assets/images/gelaender/edelstahlgelaender/data';
import {edelstahlgelaender_ohne_fuellung} from '../../../assets/images/gelaender/edelstahlgelaender_ohne_fuellung/data';
import {edelstahlgelaender_mit_glas} from '../../../assets/images/gelaender/edelstahlgelaender_glas/data';

const initialeStates = {
    data: [stahlgelaender, edelstahlgelaender, edelstahlgelaender_mit_glas, edelstahlgelaender_ohne_fuellung],
    modell_type: 0
}

const gelaenderReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {
        case 'UPDATEMODELLTYPEGELAENDER':
            action.ev = Number(action.ev);
            copyOfState.modell_type = action.ev;
        return copyOfState;

        case 'UPDATEMODELLGELAENDER':
            let modell_index = action.ev.index;
            let modell_img = action.ev.image;
            let modell_titel = action.ev.titel;
            let modell_form = action.ev.form;

            copyOfState.data[copyOfState.modell_type].modell[0].index = modell_index;
            copyOfState.data[copyOfState.modell_type].modell[0].img = modell_img;
            copyOfState.data[copyOfState.modell_type].modell[0].titel = modell_titel;
            copyOfState.data[copyOfState.modell_type].modell[0].form = modell_form;
        return copyOfState;

        case 'UPDATEMUSTERGELAENDER':
            let muster = action.ev;
            copyOfState.data[copyOfState.modell_type].modell[0].muster = muster;
        return copyOfState;

        case 'UPDATEWRAPPERINDEXGELAENDER':
            let wrapper_ident = action.ev.ident;
            let index = action.ev.index;
                switch (wrapper_ident) {
                    case 1:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper1 = index;
                    break;
                    case 2:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper2 = index;
                    break;
                    case 3:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper3 = index;
                    break;
                    case 4:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper4 = index;
                    break;
                    case 5:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper5 = index;
                    break;
                    case 6:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper6 = index;
                    break;
                    case 7:
                        copyOfState.data[copyOfState.modell_type].wrapper[0].wrapper7 = index;
                    break;
                    default:
                        return wrapper_ident;
                }
        return copyOfState;

        //set geländer ohne Füllung to true
        case 'SETISOHNETOTRUEGELAENDER':
            copyOfState.isOhneFuellung = true;
        return copyOfState;

        case 'UPDATEGRUNDRISSGELAENDER':
            let layout = action.ev;
            copyOfState.data[copyOfState.modell_type].layout = layout;
        return copyOfState;

        //update width
        case 'UPDATEWIDTHGELAENDER':
            let width_ident = action.ev.ident;
            let width_value = action.ev.value;

                switch(width_ident) {
                    case 'width_1':
                        copyOfState.data[copyOfState.modell_type].dimensions[0].width_1 = width_value;
                    break;
                    case 'width_2':
                        copyOfState.data[copyOfState.modell_type].dimensions[0].width_2 = width_value;
                    break;
                    case 'width_3':
                        copyOfState.data[copyOfState.modell_type].dimensions[0].width_3 = width_value;
                    break;
                    default:
                        return width_ident;
                }
        return copyOfState;

        //update single elements total
        case 'UPDATEWIDTHTOTALGELAENDER':
            let total_width = action.ev;

            if (!total_width) {
                let {width_1, width_2, width_3, single_elements} =  copyOfState.data[copyOfState.modell_type].dimensions[0];
                let single_elements_total = single_elements.reduce((a, b) => Number(a) + Number(b.width), 0);
                width_1 = Number(width_1);
                width_2 = Number(width_2);
                width_3 = Number(width_3);
                copyOfState.data[copyOfState.modell_type].dimensions[0].width_total = width_1+width_2+width_3+single_elements_total;
            } else {
               copyOfState.data[copyOfState.modell_type].dimensions[0].width_total = total_width;
            }

        return copyOfState;

        //add single elements
        case 'ADDSINGLEELEMENTGELAENDER':
            let single_element_object = {
                width: ''
            }

            copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements =
            [...copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements, single_element_object];

        return copyOfState;

        //update single elements
        case 'UPDATESINGLEELEMENTGELAENDER':
            let single_element_index = action.ev.index;
            let single_element_value = action.ev.value;

            copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements[single_element_index].width = single_element_value;
            copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements =
            [...copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements];

        return copyOfState;

        //delete single elements
        case 'DELETESINGLEELEMENTGELAENDER':
            let delete_index = action.ev;

            copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements =
            copyOfState.data[copyOfState.modell_type].dimensions[0].single_elements.filter((elem, index) => index !== Number(delete_index));

        return copyOfState;

        //update kind of dimension
        case 'SELECTKINDDIMENSIONGELAENDER':
            let kind_dimension_value = action.ev;
            copyOfState.data[copyOfState.modell_type].dimensions[0].kind_dimension = kind_dimension_value;
        return copyOfState;

        //update height
        case 'UPDATEHEIGHTGELAENDER':
            let height_value = action.ev;
            copyOfState.data[copyOfState.modell_type].dimensions[0].height = height_value;
        return copyOfState;

        //update handrail form
        case 'UPDATEHANDTRAILFORMGELAENDER':
            let handrail_form = action.ev;
            copyOfState.data[copyOfState.modell_type].form_handrail[0].handtrail_form = handrail_form;
        return copyOfState;

        //update handrail endkappe
        case 'UPDATEHANDRAILENDKAPPEGELAENDER':
            let handrail_endkappe = action.ev;
            copyOfState.data[copyOfState.modell_type].form_handrail[0].endkappe = handrail_endkappe;
        return copyOfState;

        //update pfosten form
        case 'UPDATEPFOSTENFORMGELAENDER':
            let pfosten_form = action.ev;
            copyOfState.data[copyOfState.modell_type].pfosten_form = pfosten_form;
        return copyOfState;

        //update befestigungsart
        case 'UPDATEBEFESTIGUNGSARTGELAENDER':
            let befestigungsart = action.ev;
            copyOfState.data[copyOfState.modell_type].befestigungsart = befestigungsart;
        return copyOfState;

         //update steps
         case 'UPDATESTEPSGELAENDER':
            let step_index = action.ev;
            let active_steps_arr = [];
            let steps =  copyOfState.data[copyOfState.modell_type].steps[0];
            let visited_steps = copyOfState.data[copyOfState.modell_type].steps[1].visited;
            let step_icons = document.querySelectorAll(".MuiStepIcon-root");

            copyOfState.data[copyOfState.modell_type].steps[0][step_index] = true;
            copyOfState.data[copyOfState.modell_type].steps[1].visited[step_index] = step_index;

            steps.forEach((elem, index) => {
                 if(elem === true) active_steps_arr.push(index);
            });

            for (let i=0; i<active_steps_arr.length; i++) {
                step_icons[i].classList.add('MuiStepIcon-active');
            }

            copyOfState.data[copyOfState.modell_type].steps[1].active_steps = visited_steps;
        return copyOfState;

        //update all visited steps
        case 'UPDATEALLVISITEDSTEPSGELAENDER':
            copyOfState.data[copyOfState.modell_type].allVisitedSteps = true;
        return copyOfState;

        //update product to merkliste
        case 'UPDATEPRODUCTTOMERKLISTEGELAENDER':
            let update_index = action.ev;
            if (update_index) {
                copyOfState.data[update_index].is_merkliste =
                !copyOfState.data[update_index].is_merkliste;
            } else {
                copyOfState.data[copyOfState.modell_type].is_merkliste =
                !copyOfState.data[copyOfState.modell_type].is_merkliste;
            }

        return copyOfState;

        //update glastönung
        case 'UPDATEGLASARTGELAENDER':
            let glasart = action.ev;
            copyOfState.data[copyOfState.modell_type].glasart = glasart;
        return copyOfState;

        //update kind of color
        case 'SELECTKINDOFCOLORGELAENDER':
            let kind_of_color = action.ev;
            copyOfState.data[copyOfState.modell_type].colors[0].kind_of_color = kind_of_color;
        return copyOfState;

        //update color
        case 'SELECTCOLOROFGELAENDER':
            let color = action.ev.color;
            let color_index = action.ev.index;
            copyOfState.data[copyOfState.modell_type].colors[0].color_index = color_index;
            copyOfState.data[copyOfState.modell_type].colors[0].color = color;
            copyOfState.data[copyOfState.modell_type].colors[0].wish_color = '';
        return copyOfState;

        //update wish color
        case 'SELECTWISHCOLORGELAENDER':
            let wish_color = action.ev;
            copyOfState.data[copyOfState.modell_type].colors[0].wish_color = wish_color;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATAGELAENDER':
            const fileSize = action.ev.file.size;
            const bytesToMegaBytes = fileSize / (1024 ** 2);
            if (bytesToMegaBytes>5) {
                copyOfState.data[copyOfState.modell_type].data_description[0].isUploadData = false;
            } else {
                let data_file = action.ev.file;
                copyOfState.data[copyOfState.modell_type].data_description[0].file = data_file;
                copyOfState.data[copyOfState.modell_type].data_description[0].isUploadData = true;
            }
        return copyOfState;

        //selct image of Category
        case 'SELECTIMAGECATEGORYGELAENDER':
            let urlLocation = action.ev;
            copyOfState.data[3].modell[0].url = urlLocation;
        return copyOfState;

         //update description
         case 'UPDATEDESCRIPTIONGELAENDER':
            let description = action.ev;
            copyOfState.data[copyOfState.modell_type].data_description[0].description = description;
        return copyOfState;

        default:
            return copyOfState;
    }
}

export default gelaenderReducer;